import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["list"];
  static values = {
    url: String,
  };

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: ".set-drag-handle",
      animation: 150,
      onEnd: this.onDragEnd.bind(this),
    });
  }

  onDragEnd(event) {
    const exerciseId = this.listTarget.dataset.exerciseId;
    const setId = event.item.dataset.id;
    const newPosition = event.newIndex;

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({
        exercise_set: {
          id: setId,
          position: newPosition,
        },
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          // Success handling if needed
        } else {
          console.error("Error updating position:", data.errors);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}
